module.exports = __webpack_public_path__ + "img/3.18815540.jpg";